export default "__VITE_ASSET__jbJ1x_vt__"